import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "mueller_cart_v1";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try {
            const raw = localStorage.getItem(KEY);
            const parsed = raw ? JSON.parse(raw) : [];
            return Array.isArray(parsed) ? parsed : [];
        } catch {
            return [];
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem(KEY, JSON.stringify(items));
        } catch {
            /* ignore */
        }
    }, [items]);

    const api = useMemo(() => {
        const add = (it, qty = 1) =>
            setItems((prev) => {
                const i = prev.findIndex((x) => x.sku === it.sku);
                if (i >= 0) {
                    const next = [...prev];
                    next[i] = { ...next[i], qty: Math.min(9999, next[i].qty + qty) };
                    return next;
                }
                return [...prev, { sku: it.sku, name: it.name, ref: it.ref || "", price: it.price, qty: Math.min(9999, Math.max(1, qty)) }];
            });
        const setQty = (sku, qty) =>
            setItems((prev) => (qty <= 0 ? prev.filter((x) => x.sku !== sku) : prev.map((x) => (x.sku === sku ? { ...x, qty: Math.min(9999, qty) } : x))));
        const remove = (sku) => setItems((prev) => prev.filter((x) => x.sku !== sku));
        const clear = () => setItems([]);
        const count = items.reduce((n, x) => n + x.qty, 0);
        const totalCents = items.reduce((n, x) => n + x.qty * x.price, 0);
        return { items, add, setQty, remove, clear, count, totalCents };
    }, [items]);

    return <CartContext.Provider value={api}>{children}</CartContext.Provider>;
}

export function useCart() {
    return useContext(CartContext);
}
